import React, { Component } from 'react';
import { Container } from './styles';
import { Link, Redirect } from 'react-router-dom';

import Config from '../../assets/icones/icon_config.svg';
import Financeiro from '../../assets/icones/icon_financeiro.svg';
import Invoice from '../../assets/icones/invoice.png';

import Home from '../../assets/icones/icon_home.svg';
import Logout from '../../assets/icones/icon_logout.svg';
import Produtos from '../../assets/icones/icon_products.svg';
import Promo from '../../assets/icones/icon_promo.svg';
import Rating from '../../assets/icones/icon_rating.svg';
import Report from '../../assets/icones/icon_report.svg';
import Ajuda from '../../assets/icones/icon_ajuda.svg';
import Training from '../../assets/icones/icon_training.svg';

import BrancoConfig from '../../assets/icones/brancos/icon_config.svg';
import BrancoFinanceiro from '../../assets/icones/brancos/icon_financeiro.svg';
import BrancoInvoice from '../../assets/icones/brancos/invoice.png';
import BrancoHome from '../../assets/icones/brancos/icon_home.svg';
// import BrancoLogout from '../../assets/icones/brancos/icon_logout.svg';
import BrancoProdutos from '../../assets/icones/brancos/icon_products.svg';
import BrancoPromo from '../../assets/icones/brancos/icon_promo.svg';
import BrancoRating from '../../assets/icones/brancos/icon_rating.svg';
import BrancoReport from '../../assets/icones/brancos/icon_report.svg';
import BrancoAjuda from '../../assets/icones/brancos/icon_ajuda.svg';
import BrancoTraining from '../../assets/icones/brancos/icon_training.svg';

export default class Nav extends Component {

    constructor(props) {
        super(props);
        this.local = ["", ((props.location.pathname).split('/', 2))[1]]
        this.state = {
            path: this.local,
            redirect: false
        }
    }

    componentDidMount() {
        this.props.history.listen((location, action) => {
            // console.log(`The current URL is ${(location.pathname).split('/', 2)}${location.search}${location.hash}`);
            this.setState({
                path: (location.pathname).split('/', 2)
            })
            // console.log(`The last navigation action was ${action}`)
        })
    }

    async logout() {
        try {
            await localStorage.removeItem('@username');
            await localStorage.removeItem('@jwt');
            await localStorage.removeItem('@user');
            await localStorage.removeItem('@rest');
            await localStorage.removeItem('@internal');
            await localStorage.removeItem('@uf');
            await localStorage.removeItem('@suser');
            this.setState({
                redirect: true
            });
        } catch (e) {
            console.log(e.data);
        }
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to='/login' />
        }
        return (
            <Container>
                <div className="telas">

                    {/* <Link to="/"  */}
                    <Link
                        style={{ textDecoration: 'none' }}>
                        <div className={this.state.path[1] === "" ? "telaatual" : "tela-not-allowed"}>
                            <img alt="" src={this.state.path[1] === "" ? BrancoHome : Home}
                                className="icones" />
                            <h3>
                                Início
                            </h3>
                        </div>
                    </Link>

                    {/* <Link to="/aval" */}
                    <Link to="/avaliacoes"
                        style={{ textDecoration: 'none' }}>
                        <div className={this.state.path[1] === "avaliacoes" ? "telaatual" : "tela"}>
                            <img alt="" src={this.state.path[1] === "avaliacoes" ? BrancoRating : Rating}
                                className="icones" />
                            <h3>
                                Avaliações
                            </h3>
                        </div>
                    </Link>

                    {/* <Link to="/relatorio" */}
                    <Link to ="/minhas-vendas"
                        style={{ textDecoration: 'none' }}>
                        <div className={this.state.path[1] === "minhas-vendas" ? "telaatual" : "tela"}>
                            <img alt="" src={this.state.path[1] === "minhas-vendas" ? BrancoReport : Report}
                                className="icones" />
                            <h3>
                                Minhas vendas
                            </h3>
                        </div>
                    </Link>

                    <Link to="/produtos"
                        style={{ textDecoration: 'none' }}>
                        <div className={this.state.path[1] === "produtos" ? "telaatual" : "tela"}>
                            <img alt="" src={this.state.path[1] === "produtos" ? BrancoProdutos : Produtos}
                                className="icones" />
                            <h3>
                                Produtos
                            </h3>
                        </div>
                    </Link>

                    <Link to="/promocoes"
                       
                        style={{ textDecoration: 'none' }}>
                        <div className={this.state.path[1] === "promocoes" ? "telaatual" : "tela"}>
                            <img alt="" src={this.state.path[1] === "promocoes" ? BrancoPromo : Promo}
                                className="icones" />
                            <h3>
                                Promoções
                            </h3>
                        </div>
                    </Link>

                    {/* <Link to="/financeiro" */}
                    <Link to="/financeiro"
                        style={{ textDecoration: 'none' }}>
                        <div className={this.state.path[1] === "financeiro" ? "telaatual" : "tela"}>
                            <img alt="" src={this.state.path[1] === "financeiro" ? BrancoInvoice : Invoice}
                                className="icones" />
                            <h3>
                                Financeiro
                            </h3>
                        </div>
                    </Link>

                    {/* <Link to="/treinamento" */}
                    {/* <Link
                    style={{ textDecoration: 'none' }}>
                    <div className={this.state.path[1] === "treinamento" ? "telaatual" : "tela-not-allowed"}>
                    <img alt="" src={this.state.path[1] === "treinamento" ? BrancoTraining : Training} 
                        className="icones"/>
                        <h3>
                        Treinamento
                        </h3>
                    </div> 
                    </Link> */}

                    <Link to="/ajuda"

                        style={{ textDecoration: 'none' }}>
                        <div className={this.state.path[1] === "ajuda" ? "telaatual" : "tela"}>
                            <img alt="" src={this.state.path[1] === "ajuda" ? BrancoAjuda : Ajuda}
                                className="icones" />
                            <h3>
                                Ajuda
                            </h3>
                        </div>
                    </Link>

                    <Link
                        to="/configuracoes"
                        style={{ textDecoration: 'none' }}>
                        <div className={this.state.path[1] === "configuracoes" ? "telaatual" : "tela"}>
                            <img alt="" src={this.state.path[1] === "configuracoes" ? BrancoConfig : Config}
                                className="icones" />
                            <h3>
                                Configurações
                            </h3>
                        </div>
                    </Link>

                    <hr />

                    <div
                        onClick={async () => await this.logout()}
                        className="sair">
                        <img alt="" src={Logout}
                            className="icones" />
                        <h3>
                            Sair
                        </h3>
                    </div>
                </div>

            </Container>
        )
    }
}